import React from "react";
import "./ItemCard.css";

import { Link } from "react-router-dom";

//redux actions;
import { addToCart, initialShow, initialError /*, removeFromCart, incrementCart*/} from "../../feature/cartSlice";
import { useDispatch, useSelector } from 'react-redux';

function ItemCard(props) {
    
    // console.log(props);
    
    const dispatch = useDispatch();
    const error = useSelector(state => state.cart.error)

    return (
        <>
            {props.data.map((item, index) => (
            <div
                key={index}
                className="shop__item"
                style={{ backgroundColor: `${item.cardColor}` }}
            >
                <p>{item.name}</p>

                <div className="item__content">
                <img className="Item__image" src={item.image} alt={item.name} />
                <p>${item.price}</p>
                <br />
                <p>{item.description_short}</p>
                </div>

                <div className="buttons__div">
                    <button
                        onClick={() => {
                            // console.log(error)
                            if (error) setTimeout(() => { dispatch(initialError()) }, 5000)
                            dispatch(addToCart(item))
                            setTimeout(() => dispatch(initialShow()), 5000)
                        }}
                        className="addToCart"
                        
                    >
                        Add To Cart
                    </button>
                    
                    <Link
                        to={`${props.route ? "shop/" : ""}${
                        props.category || item.type
                        }/${item.id}`}
                        className="view__item"
                    >
                        View Item
                    </Link>
                </div>
            </div>
            ))}
        </>
    );
}

export default ItemCard;
